import { Routes, Route, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Wallet from './pages/Wallet'
import Cards from './pages/Cards'
import Treasury from './pages/Treasury'
import Rewards from './pages/Rewards'
import Settings from './pages/Settings'
import Landing from './pages/Landing'

function App() {
  // Check if user is authenticated (mock)
  const isAuthenticated = true

  if (!isAuthenticated) {
    return <Landing />
  }

  return (
    <AnimatePresence mode="wait">
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/treasury" element={<Treasury />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </AnimatePresence>
  )
}

export default App